"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadMoreFromConnection = void 0;
exports.getNodes = getNodes;
const typed_primitives_1 = require("@sixfold/typed-primitives");
function getNodes(items) {
    return items?.edges?.map((edge) => edge?.node).filter(typed_primitives_1.notNil) ?? [];
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function path(keys, object) {
    return keys.reduce((object, next) => {
        if (object === undefined) {
            return undefined;
        }
        return object[next];
    }, object);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setValue(keys, object, value) {
    if (keys.length === 0) {
        return value;
    }
    const result = object ? { ...object } : {};
    result[keys[0]] = setValue(keys.slice(1), object[keys[0]], value);
    return result;
}
const loadMoreFromConnection = async (query, result, connectionKeyPath, pageSize) => {
    const connection = path(connectionKeyPath, result.data);
    if (result.data === undefined ||
        result.fetchMore === undefined ||
        (0, typed_primitives_1.isNil)(connection) ||
        (0, typed_primitives_1.isNil)(connection.pageInfo) ||
        (0, typed_primitives_1.isNil)(connection.pageInfo.hasNextPage) ||
        !connection.pageInfo.hasNextPage) {
        return;
    }
    return await result.fetchMore({
        query,
        variables: Object.assign({}, result.variables, {
            ...(pageSize !== undefined ? { first: pageSize } : {}),
            cursor: connection.pageInfo.endCursor,
        }),
        updateQuery: (previousResult, { fetchMoreResult }) => {
            if (fetchMoreResult === undefined) {
                return previousResult;
            }
            const newConnection = path(connectionKeyPath, fetchMoreResult);
            if ((0, typed_primitives_1.isNil)(newConnection)) {
                return previousResult;
            }
            const newEdges = newConnection.edges;
            const pageInfo = newConnection.pageInfo;
            const result = setValue(connectionKeyPath, fetchMoreResult, {
                ...newConnection,
                edges: (0, typed_primitives_1.notNil)(newEdges) && (0, typed_primitives_1.notNil)(connection.edges) ? [...connection.edges, ...newEdges] : null,
                pageInfo,
            });
            return result;
        },
    });
};
exports.loadMoreFromConnection = loadMoreFromConnection;
//# sourceMappingURL=connection.js.map